import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd-mobile';
import useLogin from '@/hooks/useLogin';
import cx from './index.module.scss';

interface Props {}

const Nav: React.FC<Props> = () => {
  const navigate = useNavigate();

  const { isLogin } = useLogin();

  const navs = [
    {
      name: '首页',
      url: '/',
    },
    {
      name: '登录页',
      url: '/login',
    },
    {
      name: '个人信息页',
      url: '/user/user-info',
    },
    {
      name: '添加会员页',
      url: '/user/add-member',
    },
    {
      name: '搜索会员页',
      url: '/user/search-member',
    },
    {
      name: '会员详情页',
      url: '/user/member-detail',
    },
    {
      name: '新建服务',
      url: '/service/add-service',
    },
    {
      name: '手诊',
      url: '/service/hand-diagnosis',
    },
    {
      name: '确认理疗方案',
      url: '/service/confirm-plan',
    },
    {
      name: 'AI问诊',
      url: '/ai-consultation',
    },
  ];

  return (
    <div className={cx('nav')}>
      {navs.map(item => (
        <Button color="primary" className={cx('btn')} key={item.url} onClick={() => navigate(item.url)}>
          {item.name}
        </Button>
      ))}
    </div>
  );
};

export default Nav;
